<script setup lang="ts">
import {
  IFahrer,
  IAuftrag,
} from "@/features/abrechnung/api/useAbrechnungsplan";
import FahrerAbgerechnet from "./FahrerAbgerechnet.vue";
import FahrerAbrechnen from "../actions/FahrerAbrechnen.vue";
import FahrerAbrechnenRueckgaengig from "../actions/FahrerAbrechnenRueckgaengig.vue";

defineProps<{
  fahrer: IFahrer[];
  auftrag: IAuftrag;
  query: () => void;
}>();
</script>

<template>
  <div class="flex">
    <div v-for="(f, i) in fahrer" :key="f.id" class="relative group">
      <div v-if="i > 0" class="w-px my-0.5 inline-block bg-gray-200 mx-2"></div>
      <FahrerAbgerechnet :fahrer="f" />
      <div
        class="abrechnen-block absolute z-10 top-1/2 transform whitespace-nowrap -translate-y-1/2 px-4 py-0.5 space-x-5 transition bg-white rounded shadow opacity-0 left-[100%] group-hover:opacity-100 print:shadow-none"
      >
        <FahrerAbrechnen :fahrer-id="f.id" :auftrag="auftrag" :query="query" />
        <FahrerAbrechnenRueckgaengig
          :fahrer-id="f.id"
          :auftrag="auftrag"
          :query="query"
        />
      </div>
    </div>
  </div>
</template>
